import React from 'react'

import { Formik } from 'formik'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { CodigosTransaccionesConstant } from 'constants/index'

import { Portlet, Form, Button, Row, Col } from '_zari/core'
import Yup from '_zari/validation/_yup'

import * as BackgroundJobsService from 'services/backgroundJobs.service'

import * as FormGroups from './formGroups'

const portletBreadcrumbs = [
  { name: 'Asientos Contables', path: `/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}` },
  { name: 'Libros Electrónicos' },
  { name: 'Libro Mayor' }
]

export const ValidationSchema = Yup.object().shape({
  mes: Yup.string().length(2).required()
})

const FormatoRegistroCompras = () => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      mes: __adminContext.mesTrabajo || '',
      flagDescargaExcel: false
    }
  }, [__adminContext])

  const onSubmit = React.useCallback(
    async formData => {
      await BackgroundJobsService.iniciarLibroMayor(formData)
        .then(() => {
          __zariContext.snack('info', 'Libro mayor enviado a procesos en background.')
        })
        .catch(({ data }) => __zariContext.snack('error', data?.error || 'No se pudo iniciar el proceso.'))
    },
    [__zariContext]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Libro Mayor' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          {__adminContext.mesTrabajo && (
            <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
              {({ errors, touched, isSubmitting, handleSubmit, values }) => (
                <Form>
                  <Row>
                    <Col md={6}>
                      <Row>
                        <Col md={6}>
                          <FormGroups.MesContabilidadFormGroup
                            iError={errors.mes}
                            iTouched={touched.mes}
                            fIsSubmitting={isSubmitting}
                          />
                          <FormGroups.FlagDescargaExcelFormGroup
                            fIsSubmitting={isSubmitting}
                            iValue={values.flagDescargaExcel}
                          />
                        </Col>
                        <Col md={3}>
                          <Button disabled={isSubmitting} onClick={handleSubmit}>
                            {isSubmitting ? 'Enviando proceso ...' : 'Generar en background'}
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          )}
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default React.memo(FormatoRegistroCompras)
